import { render, staticRenderFns } from "./AverageMileage.vue?vue&type=template&id=c2c925bc&lang=pug"
import script from "./AverageMileage.vue?vue&type=script&lang=js"
export * from "./AverageMileage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports